import { gql } from "@apollo/client";

export const CONFIGURE_CONNECTOR = gql`
  mutation ConfigureConnector($key: String!, $data: ConnectorDataInput!) {
    configureConnector(key: $key, data: $data) {
      key
      status
      configured
      enabled
      hasCredentials
      integrationId
      config
    }
  }
`;

const connectors = { CONFIGURE_CONNECTOR };

export default connectors;
